import React, { useState } from 'react'
import styled from 'styled-components'
import ModalLayout from './common/ModalLayout'
import MainButton from '../atoms/MainButton'
import Text from '../atoms/Text'
import BaseInput from '../atoms/BaseInput'

const TextWrapper = styled.div`
  text-align: left;
  max-width: 232px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`
const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  gap: 8px;
`

const EditTitleModal = ({ initialTitle, onClose, onConfirm }) => {
  const [localTitle, setLocalTitle] = useState(initialTitle);

  return (
    <ModalLayout>
      <TextWrapper>
        <Text variant="headline3" weight="bold">제목 수정</Text>
        <BaseInput 
          value={localTitle}
          onChange={(e) => setLocalTitle(e.target.value)}/>
      </TextWrapper>
      <ButtonWrapper>
        <MainButton
          $variant="cancel"
          $size="small"
          title="취소"
          onClick={onClose}/>
        <MainButton
          $variant="primary"
          $size="small"
          title="확인"
          onClick={() => onConfirm(localTitle)}/>
      </ButtonWrapper>
    </ModalLayout>
  )
}

export default EditTitleModal
